<template>
  <div>
    <AutoSendoutFailed></AutoSendoutFailed>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AutoSendoutFailed = defineAsyncComponent(() =>
  import("@/components/sendOuts/AutoSendoutFailed")
);
export default {
  components: {
    AutoSendoutFailed,
  },
};
</script>
